// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import { KeyValueSchema } from './KeyValueSchema'
import type { KeyValue } from './KeyValueSchema'
import { CookieSchema } from './CookieSchema'
import type { Cookie } from './CookieSchema'
import { HttpRequestSchema } from './HttpRequestSchema';

/////////////////////////////////////////
// HTTP REQUEST RELATION SCHEMA
/////////////////////////////////////////

export type HttpRequestRelations = {
  headers: KeyValue[];
  cookies: Cookie[];
  searchParams: KeyValue[];
};

export type HttpRequestWithRelations = z.infer<typeof HttpRequestSchema> & HttpRequestRelations

export const HttpRequestWithRelationsSchema: z.ZodType<HttpRequestWithRelations> = HttpRequestSchema.merge(z.object({
  headers: z.lazy(() => KeyValueSchema).array(),
  cookies: z.lazy(() => CookieSchema).array(),
  searchParams: z.lazy(() => KeyValueSchema).array(),
}))